import React from 'react';
import './AboutMe.css';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import CodeIcon from '@mui/icons-material/Code';
import PersonIcon from '@mui/icons-material/Person';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';

function AboutMe({ username = "User", onClose }) {
    // Получаем первую букву имени для аватара
    const getInitial = () => {
        return username ? username.charAt(0).toUpperCase() : 'U';
    };

    // Пример данных пользователя
    const userData = {
        name: username,
        role: "Администратор",
        experience: "5+ years",
        projects: "42 completed",
        email: `${username.toLowerCase()}@company.com`,
        phone: "+7 777 777 77 77",
        location: "Россия, Воронеж",
        bio: "Старший администратор производственного комплекса \"N\"\n" +
            "\n" +
            "С более чем 15-летним опытом работы в промышленном секторе.",
        education: "Воронежский государственный технический университет",
        skills: [
            { name: "Коммуникативность", level: 95 },
            { name: "Управление персоналом", level: 90 },
            { name: "ERP-системы", level: 85 },
            { name: "Логистика", level: 80 },
            { name: "Лидерские качества", level: 75 },
            { name: "Техническая грамотность", level: 70 }
        ]
    };

    const handleDownloadCV = () => {
        alert('CV download functionality would be implemented here!');
        // Здесь можно реализовать скачивание CV
    };

    const handleShareProfile = () => {
        if (navigator.share) {
            navigator.share({
                title: `${userData.name}'s Profile`,
                text: `Check out ${userData.name}'s profile - ${userData.role}`,
                url: window.location.href
            });
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('Profile link copied to clipboard!');
        }
    };

    return (
        <div className="about-me-container" onClick={onClose}>
            <div className="about-me-modal" onClick={e => e.stopPropagation()}>
                <div className="about-me-header">
                    <h2>Обо мне</h2>
                    <button className="close-button" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>

                <div className="about-me-content">
                    <div className="about-me-sidebar">
                        <div className="profile-avatar">
                            <div className="avatar-initial">{getInitial()}</div>
                        </div>

                        <div className="profile-info">
                            <h3 className="profile-name">{userData.name}</h3>
                            <span className="profile-role">{userData.role}</span>
                        </div>
                    </div>

                    <div className="about-me-main">
                        <div className="about-section">
                            <h3>
                                <PersonIcon />
                                Биография
                            </h3>
                            <p className="about-text">
                                {userData.bio}
                            </p>
                        </div>

                        <div className="about-section">
                            <h3>
                                <WorkIcon />
                                Навыки и Опыт
                            </h3>
                            <div className="skills-grid">
                                {userData.skills.map((skill, index) => (
                                    <div key={index} className="skill-item">
                                        <div className="skill-header">
                                            <span className="skill-name">{skill.name}</span>
                                            <span className="skill-level">{skill.level}%</span>
                                        </div>
                                        <div className="skill-bar">
                                            <div
                                                className="skill-progress"
                                                style={{ width: `${skill.level}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="about-section">
                            <h3>
                                <SchoolIcon />
                                Образование
                            </h3>
                            <p className="about-text">{userData.education}</p>
                        </div>

                        <div className="about-section">
                            <h3>
                                <CodeIcon />
                                Контакты
                            </h3>
                            <div className="contact-list">
                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <EmailIcon />
                                    </div>
                                    <div className="contact-info">
                                        <h4>Почта</h4>
                                        <p>{userData.email}</p>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <PhoneIcon />
                                    </div>
                                    <div className="contact-info">
                                        <h4>Телефон</h4>
                                        <p>{userData.phone}</p>
                                    </div>
                                </div>

                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <LocationOnIcon />
                                    </div>
                                    <div className="contact-info">
                                        <h4>Расположение</h4>
                                        <p>{userData.location}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="action-buttons">
                            <button className="primary-action-button" onClick={handleDownloadCV}>
                                <DownloadIcon />
                                Download CV
                            </button>
                            <button className="secondary-action-button" onClick={handleShareProfile}>
                                <ShareIcon />
                                Share Profile
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutMe;